import type { MeetingUrl } from "@frontierx/types";
import { FaGoogle, FaMicrosoft, FaVideo } from "react-icons/fa";
import { SiZoom } from "react-icons/si";

export interface CallServiceIconProps {
  url: string | MeetingUrl;
}

export function CallServiceIcon({ url }: Readonly<CallServiceIconProps>) {
  if (typeof url === "string") {
    let hostname: string | undefined;
    try {
      const parsedUrl = new URL(url.trim());
      hostname = parsedUrl?.hostname;
    } catch (e) {
      console.error("Error parsing URL", e);
    }

    if (hostname?.includes("google")) {
      return (
        <div className="flex items-center">
          <FaGoogle className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("zoom")) {
      return (
        <div className="flex items-center">
          <SiZoom className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("teams.live.com")) {
      return (
        <div className="flex items-center">
          <FaMicrosoft className="mr-2" />
        </div>
      );
    }
    if (hostname?.includes("teams.microsoft")) {
      return (
        <div className="flex items-center">
          <FaMicrosoft className="mr-2" />
        </div>
      );
    }
    // Default case for unsupported or unknown services
    return (
      <div className="flex items-center">
        <FaVideo className="mr-2" />
      </div>
    );
  }

  const { platform } = url;

  if (platform === "google_meet") {
    return (
      <div className="flex items-center">
        <FaGoogle className="mr-2" />
      </div>
    );
  }
  if (platform === "zoom") {
    return (
      <div className="flex items-center">
        <SiZoom className="mr-2" />
      </div>
    );
  }
  if (platform === "microsoft_teams" || platform === "microsoft_teams_live") {
    return (
      <div className="flex items-center">
        <FaMicrosoft className="mr-2" />
      </div>
    );
  }
  // Default case for unsupported or unknown platforms
  return (
    <div className="flex items-center">
      <FaVideo className="mr-2" />
    </div>
  );
}
